import Vue from "vue";
import api from "@/api";
import events from "@/events";
import notify from "@/utils/notify";
import globals from "@/utils/globals";
import cookie from "@/utils/cookie";

const state = {
  items: []
};

const mutations = {
  items: (state, payload) => {
    Vue.set(state, "items", payload);
  }
};

const getters = {
  plans: (state) => {
    return state.items.map(a => a.plan);
  },
  trialDays: (state, getters) => {
    if (state.items.length > 0) {
      const yearlyPlan = getters.yearlyPlan;
      if (yearlyPlan) {
        return yearlyPlan.trialDays;
      }
    }
    return 0;
  },
  planByType: (state, getters) => type => {
    return getters.plans.find(a => a.type === type);
  },
  currency: (state, getters) => {
    return (getters.plans.length && getters.plans[0].currency) || "usd";
  },
  libraryTotalWorth: (state, getters) => {
    return globals.libraryTotalWorth[getters.currency.toUpperCase()] || globals.libraryTotalWorth["USD"];
  },
  couponByType: (state) => type => {
    const plan = state.items.find(a => a.plan.type === type);
    return plan && plan.coupon;
  },
  plansByDurations: (state, getters) => (durations = []) => {
    const plans = getters.plans.filter(p => {
      return durations.length <= 0 || durations.indexOf(p.duration) >= 0;
    });
    return plans;
  },
  yearlyPlan: (state, getters) => {
    return getters.planByType("yearly");
  },
  currencyDisclaimer: (state, getters) => {
    for (let plan of getters.plans) {
      if (plan.disclaimer) {
        return plan.disclaimer;
      }
    }
  },
  yearlySavedPercents: (state, getters) => {
    const yearlyPlan = getters.yearlyPlan;
    const monthlyPlan = getters.planByType("monthly");
    if (yearlyPlan && monthlyPlan) {
      return 100 - Math.round(yearlyPlan.price.perMonth.value * 100 / monthlyPlan.price.perMonth.value);
    }
  },
  firstPlan: (state, getters) => {
    return getters.plans.length > 0 && getters.plans[0];
  },
  freeMarkup: (state, getters) => {
    return getters.firstPlan && getters.firstPlan.freeMarkup;
  }
};

const actions = {
  load: ({ commit, rootGetters }) => {
    api.plans({
      code: cookie("coupon_code") || globals.couponCode
    })
      .then(data => {
        commit("items", data.plans);
        events.emit("plans:ready", {
          plans: data.plans,
          canTrial: rootGetters.canTrial
        });
      })
      .catch(error => {
        notify("Failed to fetch plans");
        events.emit("plans:error", error);
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
